export const colors = {
  success: '#10dc60',
  secondary: '#0cd1e8',
  tertiary: '#7044ff',
  primary: '#3880ff',
  warning: '#ffce00',
  danger: '#f04141',
  dark: '#222428',
  medium: '#989aa2',
  light: '#f4f5f8',
  white: '#ffffff'
}
